// @core/stores/secret/SecretAuditStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { secretApi } from '@core/api';
import type {
  ListAuditEntriesResponse,
} from '@core/types/secret';

class SecretAuditStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * List audit entries
   */
  async ListAuditEntries(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; from?: string | number | boolean; limit?: string | number | boolean; operation?: string | number | boolean; path?: string | number | boolean; sort?: string | number | boolean; to?: string | number | boolean; }): Promise<ListAuditEntriesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.ListAuditEntries(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const secretAuditStore = new SecretAuditStore();
